<mat-drawer-container autosize style="background: white">

    <mat-drawer #drawer [mode]="'side'" position="end">
        <div class="container">
            <h3 class="padding-top-15">Filters</h3>
            <mat-divider></mat-divider>
            <mat-form-field class="padding-top-15">
                <mat-label>Location</mat-label>
                <mat-select [(ngModel)]="filters.location.value" (selectionChange)="updateFilter()">
                    <mat-option value="">All locations</mat-option>
                    <mat-option *ngFor="let location of filters.location.options"
                                [value]="location.vetSuccessPracticeId">{{location.name}}</mat-option>
                </mat-select>
            </mat-form-field>
            <div class="col col-lg-4 padding-top-10">
                <mat-checkbox style="padding-top: 20px" [(ngModel)]="showUnmappedOnly"
                              (change)="reset()">
                    Show Unmapped Only
                </mat-checkbox>
            </div>
            <br/>
            <button (click)="drawer.toggle()" mat-stroked-button>
                <mat-icon aria-hidden="false">close</mat-icon>
                Close
            </button>&nbsp;
            <button (click)="resetGrid()" mat-stroked-button color="accent">
                <mat-icon aria-hidden="false">refresh</mat-icon>
                Reset
            </button>
        </div>
    </mat-drawer>

    <mat-drawer-content style="padding-top: 15px">
        <h5 class="card-title text-muted">Providers</h5>
        <mat-divider></mat-divider>

        <div class="row">
            <div class="col col-lg-4">
                <form class="form-inline list-employee-search-header">
                    <mat-form-field class="toast-top-full-width" appearance="standard">
                        <mat-label>Search by name or ID in external system</mat-label>
                        <input type="text"
                               placeholder=""
                               aria-label="Search"
                               matInput
                               (input)="updateFilter()" [(ngModel)]="filters.searchQuery.value">
                    </mat-form-field>
                </form>
            </div>
            <div class="col col-lg-5">
                <button mat-icon-button color="primary" (click)="drawer.toggle()" class="margin-top-15">
                    <mat-icon aria-hidden="false">tune</mat-icon>
                    <span *ngIf="calculateActiveFiltersCount() > 0"
                          class="badge badge-small">{{calculateActiveFiltersCount()}}</span>
                </button>
            </div>
            <div class="col col-lg-2">
                <a href="https://employee.{{envPrefix}}rbcompanion.com/employees/unmatched-records" mat-icon-button
                   color="primary" target="_blank" class="padding-top-15">
                    Map providers in Employee Service
                    <i class="bi bi-box-arrow-up-right"></i>
                </a>
            </div>
        </div>
        <mat-divider></mat-divider>

        <div class="table-container">
            <div class="table-loading-shade"
                 *ngIf="isLoadingResults">
                <mat-spinner [diameter]="50" *ngIf="isLoadingResults"></mat-spinner>
            </div>

            <div class="table-box">
                <table mat-table [dataSource]="data"
                       matSort matSortActive="updatedAt" matSortDisableClear matSortDirection="desc">

                    <ng-container matColumnDef="netSuiteEmployeeFullName" sticky>
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
                        <td mat-cell *matCellDef="let row">{{row.name}}</td>
                    </ng-container>

                    <ng-container matColumnDef="location">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Location</th>
                        <td style="white-space: pre-line;" mat-cell *matCellDef="let row">{{row.location}}</td>
                    </ng-container>

                    <ng-container matColumnDef="vetSuccessTransactionProviderId">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Vetsource Id</th>
                        <td mat-cell *matCellDef="let row">{{row.vetSourceId}}</td>
                    </ng-container>

                    <ng-container matColumnDef="netSuiteEmployeeEntityId">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Netsuite Id</th>
                        <td mat-cell *matCellDef="let row">{{row.netSuiteId}}</td>
                    </ng-container>

                    <ng-container matColumnDef="updatedAt">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Updated At</th>
                        <td mat-cell *matCellDef="let row">{{row.updatedAt | date}}</td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>

            </div>

            <mat-paginator [length]="resultsLength" [pageSize]="pageSize"
                           [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
        </div>

    </mat-drawer-content>
</mat-drawer-container>
